// Ready Player Me Configuration
export const READY_PLAYER_ME_CONFIG = {
  subdomain: 'wakarunning',
  // This will be used to construct the avatar creation URL
  baseUrl: 'https://wakarunning.readyplayer.me',
  
  // Avatar creation settings
  avatarCreationSettings: {
    // Allow users to customize their avatar
    allowCustomization: true,
    // Allow users to take a photo for avatar generation
    allowPhotoUpload: true,
    // Gender options
    gender: 'neutral' as 'male' | 'female' | 'neutral',
    // Body type
    bodyType: 'fullbody' as 'fullbody' | 'halfbody',
  },
  
  // Avatar display settings
  displaySettings: {
    // Quality of the avatar (lower = faster loading)
    quality: 'medium' as 'low' | 'medium' | 'high',
    // Size of the avatar
    size: 512,
    // Background color
    backgroundColor: '#f5f5f5',
  }
};

// Helper function to generate avatar creation URL
export const getAvatarCreationUrl = (userId: string, redirectUrl?: string): string => {
  const baseUrl = `${READY_PLAYER_ME_CONFIG.baseUrl}/avatar`;
  const params = new URLSearchParams({
    userId: userId,
    gender: READY_PLAYER_ME_CONFIG.avatarCreationSettings.gender,
    bodyType: READY_PLAYER_ME_CONFIG.avatarCreationSettings.bodyType,
  });
  
  if (redirectUrl) {
    params.append('redirectUrl', redirectUrl);
  }
  
  return `${baseUrl}?${params.toString()}`;
};

// Helper function to get avatar URL for display
export const getAvatarUrl = (avatarId: string, options?: {
  size?: number;
  quality?: 'low' | 'medium' | 'high';
  backgroundColor?: string;
  format?: 'glb' | 'png' | 'jpg';
}): string => {
  const { size = 512, quality = 'medium', backgroundColor = '#f5f5f5', format = 'png' } = options || {};
  
  if (format === 'glb') {
    // For 3D models
    return `${READY_PLAYER_ME_CONFIG.baseUrl}/api/avatar/${avatarId}.glb?size=${size}&quality=${quality}&backgroundColor=${encodeURIComponent(backgroundColor)}`;
  } else {
    // For 2D images (PNG/JPG) - use the correct Ready Player Me API endpoint
    return `${READY_PLAYER_ME_CONFIG.baseUrl}/api/avatar/${avatarId}.${format}?size=${size}&quality=${quality}&backgroundColor=${encodeURIComponent(backgroundColor)}`;
  }
};
